// src/polaris-components/StripeProvider.tsx
import React, { ReactNode, useState, useEffect } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { getConfig } from '../utils/config';

interface StripeProviderProps {
  children: ReactNode;
}

/**
 * StripeProvider wraps the application with Stripe Elements context
 * This should be placed high in the component tree to provide Stripe functionality
 */
export const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);

  useEffect(() => {
    const config = getConfig();
    if (!config.stripePublishableKey) {
      console.warn('REACT_APP_STRIPE_PUBLISHABLE_KEY is not set. Stripe functionality will not work.');
      setStripePromise(Promise.resolve(null));
    } else {
      setStripePromise(loadStripe(config.stripePublishableKey));
    }
  }, []);

  if (stripePromise === null) {
    return <div>Loading payment system...</div>;
  }

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

